import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../../../api";

const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token") || sessionStorage.getItem("accessToken");
    const uid = sessionStorage.getItem("uid");

    return {
        Authorization: token ? `Bearer ${token}` : "",
        uid,
    };
};

const useTreatmentDelegation = ({ endpoint, label, onUpdated }) => {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadDelegationSetting = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}${endpoint}`, {
                    headers: getAuthHeaders(),
                });
                if (!response.ok) return;
                const data = await response.json();
                setEnabled(!!data.enabled);
            } catch (error) {
                console.error(`Erreur chargement délégation ${label}:`, error);
            }
        };

        loadDelegationSetting();
    }, [endpoint, label]);

    const toggle = async (nextEnabled) => {
        const confirmed = window.confirm(
            nextEnabled
                ? `Activer la délégation ? Les demandes ${label} en attente seront transmises à l'Admin RH.`
                : "Désactiver la délégation automatique vers l'Admin RH ?"
        );
        if (!confirmed) return;

        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}${endpoint}?enabled=${nextEnabled}`, {
                method: "POST",
                headers: getAuthHeaders(),
            });
            if (!response.ok) throw new Error("Impossible de mettre à jour la délégation.");
            const data = await response.json();
            setEnabled(!!data.enabled);
            if (onUpdated) onUpdated();
        } catch (error) {
            console.error(`Erreur délégation ${label}:`, error);
            window.alert(error.message || "Impossible de mettre à jour la délégation.");
        } finally {
            setLoading(false);
        }
    };

    return { enabled, loading, toggle };
};

export default useTreatmentDelegation;
